import { Env } from '@/env/index'

let env!: Env

if (process.env.NODE_ENV === 'production') {
    env = {
        basePath: 'https://radio17.pl',
        pusherKey: '2ff25343012c8a40d5bd',
        googleAnalyticsId: 'UA-97907507-2',
        sentryDsn: 'https://2e2eed78d70b4475a972b7a1641ba56c@o1372594.ingest.sentry.io/6000744'
    }
} else {
    env = {
        basePath: 'http://radio17.pl.test',
        pusherKey: '',
        googleAnalyticsId: '',
        sentryDsn: ''
    }
}

export default env
